import setUserlog from "./setUser";
import setteamlistData from "./teamlistData";
import setcatlistData from "./catlistData";
import setplayerlistData from "./playerlistData";
import settodayAuction from "./todayAuction";
import setupcomingActlistData from "./upcomingActlistData";
import setactlistData from "./actlistData";
import setRefresh from "./getRefresh";
import setJoinAuction from "./joinAuction";
import isjoin from "./isjoin";
import updtoken from "./updtoken";
import updtoken2 from "./updtoken2";
import aucid from "./aucid";
import isfirsttime from "./isfirsttime";
import { combineReducers } from "redux";
import actmoredata from "./actmoredata";
import setplfilters from "./plfilters";

const rootReducer = combineReducers({
    setUserlog,
    setteamlistData,
    setcatlistData,
    setplayerlistData,
    setactlistData,
    settodayAuction,
    setupcomingActlistData,
    setRefresh,
    setJoinAuction,
    isjoin,
    setplfilters,
    updtoken,
    updtoken2,
    aucid,
    isfirsttime,
    actmoredata
    
})

export default rootReducer;

